import { createMessage } from '@wetransfer/native-message-exchange-js';

export const tokenRequestMessage = createMessage('TOKEN_REQUEST');

interface TokenResponse {
  accessToken: string;
  idToken: string;
}
export const tokenResponseMessage =
  createMessage<TokenResponse>('TOKEN_RESPONSE');
